import { ThreeDots } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useGetInCompletedTodosQuery } from "../features/api/apiSlice";
import { inCompleteFilter } from "../features/filterSlice/filterSlice";

const numberOfTodos = (no_of_todos) => {
    switch (no_of_todos) {
        case 0:
            return "No task";
        case 1:
            return "1 task";
        default:
            return `${no_of_todos} tasks`;
    }
};

export default function Footer() {
    const { inCompleteFilter: colors } = useSelector((state) => state.filter);
    const { data: inCompletedTodos = [], isLoading } = useGetInCompletedTodosQuery(colors);

    const dispatch = useDispatch();
    // const filters = useSelector((state) => state.filters);

    // const dispatch = useDispatch();

    // const todosRemaining = todos.filter((todo) => !todo.completed).length;

    // const {
    //     // status, 
    //     colors
    // } = filters;

    // const handleStatusChange = (status) => {
    //     dispatch(statusChanged(status));
    // };

    const handleColorChange = (color) => {
        let values = [...colors];
        if (colors.includes(color)) {
            values = values.filter(c => {
                return color !== c;
            })
        } else {
            values.push(color)
        }
        dispatch(inCompleteFilter(values));
    };

    return (
        <div className="mt-4 flex justify-between text-xs text-gray-500">
            {isLoading ? <ThreeDots
                height="30"
                width="30"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
            />
                :
                <>
                    <p>{numberOfTodos(inCompletedTodos.length)} left</p>
                    <ul className="flex space-x-1 items-center text-xs">
                        <li
                            className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${colors.includes("green") && "bg-green-500"
                                }`}
                            onClick={() => handleColorChange("green")}
                        ></li>
                        <li
                            className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${colors.includes("red") && "bg-red-500"
                                }`}
                            onClick={() => handleColorChange("red")}
                        ></li>
                        <li
                            className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${colors.includes("yellow") && "bg-yellow-500"
                                }`}
                            onClick={() => handleColorChange("yellow")}
                        ></li>
                    </ul>
                </>
            }
        </div>
    );
}
